import React, { useEffect, useState } from 'react';
import VehicleOffersListComponent from '../../components/vehicle-offers-list-component/vehicle-offers-list-component';
import ComparisonPanel from '../../components/comparison-panel/comparison-panel-redux';
import { withRouter } from 'react-router-dom';
import classes from './fahrzeuge-der-car-policy-page.module.scss';
import FahrzeugeDerCarPolicyFilters from './fahrzeuge-der-car-policy-filters/fahrzeuge-der-car-policy-filters';
import { useSessionFilter } from 'hooks/use-session-filter';
import { EmployeeConfigurationsBigFilters } from './fahrzeuge-der-car-policy-filters/employee-configurations/employee-configurations';
import { useSelector } from 'react-redux';
import { Distance } from '../../common/common-components.styled';
import { ConfigurationTypes } from '../../common/enums';
import ConfigurationTypeTile from '../../components/configuration-type-tile';
import SideMenuRightContainer from '../../components/side-menu-right-container/side-menu-right-container';
import { StyledTilesContainer } from '../../components/configuration-type-tile/configuration-type-tile.styled';
import { useReferenceVehicleTypes } from '../../hooks/react-query/show-change-view-button';
import useOverlay from '../../hooks/use-overlay';
import { useSetFilterFromLocationState } from 'hooks/use-set-filter-from-location-state/use-set-filter-from-location-state';
import usePaginationState from '../../hooks/use-pagination-state/use-pagination-state';
import useCheckPage from '../../hooks/use-check-page';
import { useSessionState } from '../../hooks/use-session-state';

export const vehicleOfferPageLoadingKey = 'vehicleOfferPageOverlay';

const FahrzeugeDerCarPolicyPage = props => {
  const [showOverlay, hideOverlay] = useOverlay(vehicleOfferPageLoadingKey);
  const comparisonPanelOpen = useSelector(state => state['comparison'].comparisonPanelOpen);
  const comparisonCars = useSelector(state => state['comparison'].cars);

  const { isEmployeeConfigurationsPage, isNewDriverConfigurationPage, isNewEmployeeConfigurationsPage } =
    useCheckPage();
  const { defaultPage, setDefaultPage } = usePaginationState(location.pathname);
  const { state: listView, setSessionState: setListView } = useSessionState(
    'configurations-list-view',
    isEmployeeConfigurationsPage
  );
  const [tableParams, setTableParams] = useState(getDefaultTableParams(defaultPage, listView ? 20 : 10));
  const [configurationType, setConfigurationsType] = useState(null);
  const [allFiltersVisible, setAllFiltersVisibility] = useState(false);

  const { isReferenceVehiclesAvailable, isBulkOrdersAvailable, isCarConfiguratorAvailable } = useReferenceVehicleTypes(
    isNewDriverConfigurationPage || isNewEmployeeConfigurationsPage
  );
  const { sessionFilter, setSessionFilter } = useSessionFilter(
    window.location.pathname,
    EMTY_FILTER_STATE,
    EMTY_FILTER_STATE
  );

  const goToFirstPage = () => {
    setDefaultPage(1);
    setTableParams(prevState => ({
      ...prevState,
      pagination: {
        ...prevState.pagination,
        start: 1
      }
    }));
  };

  const changeListView = () => {
    setDefaultPage(1);
    setTableParams(prevState => ({
      ...prevState,
      pagination: {
        start: 1,
        number: listView ? 10 : 20
      }
    }));
    setListView(!listView);
  };

  useSetFilterFromLocationState(setSessionFilter, EMTY_FILTER_STATE, EMTY_FILTER_STATE, goToFirstPage);

  const numberOfTypesChosen = [isReferenceVehiclesAvailable, isBulkOrdersAvailable, isCarConfiguratorAvailable].reduce(
    (accumulator, currentValue) => (currentValue ? ++accumulator : accumulator),
    0
  );

  const showConfigurationTypesOptions =
    numberOfTypesChosen > 1 && (isNewDriverConfigurationPage || isNewEmployeeConfigurationsPage) && !configurationType;

  const isSetConfigurationType =
    numberOfTypesChosen === 1 && (isNewDriverConfigurationPage || isNewEmployeeConfigurationsPage);

  useEffect(() => {
    const scrollContainer = document.querySelector('.scroll-container');
    if (scrollContainer) {
      scrollContainer.scrollTo({ top: 0 });
    }
  }, []);

  useEffect(() => {
    if (showConfigurationTypesOptions) {
      hideOverlay();
    }

    return hideOverlay;
  }, [showConfigurationTypesOptions]);

  useEffect(() => {
    if (isSetConfigurationType) {
      setConfigurationsType(
        isReferenceVehiclesAvailable
          ? ConfigurationTypes.Reference
          : isBulkOrdersAvailable
          ? ConfigurationTypes.BulkOrders
          : ConfigurationTypes.CarConfigurator
      );
    }
  }, [isSetConfigurationType]);

  const options = [
    { value: 'createdon-true', label: 'Neueste zuerst' },
    { value: 'createdon-false', label: 'Älteste zuerst' }
  ];

  const renderQuickFilters = () => {
    return (
      <div className={classes.filter_wrapper}>
        {isEmployeeConfigurationsPage && (
          <EmployeeConfigurationsBigFilters
            setSessionFilter={setSessionFilter}
            sessionFilter={sessionFilter}
            goToFirstPage={goToFirstPage}
          />
        )}
      </div>
    );
  };

  if (showConfigurationTypesOptions) {
    return (
      <SideMenuRightContainer>
        <StyledTilesContainer justify='center'>
          {isBulkOrdersAvailable && (
            <ConfigurationTypeTile type={ConfigurationTypes.BulkOrders} setConfigurationsType={setConfigurationsType} />
          )}
          {isReferenceVehiclesAvailable && (
            <ConfigurationTypeTile type={ConfigurationTypes.Reference} setConfigurationsType={setConfigurationsType} />
          )}
          {isCarConfiguratorAvailable && (
            <ConfigurationTypeTile
              type={ConfigurationTypes.CarConfigurator}
              setConfigurationsType={setConfigurationsType}
            />
          )}
        </StyledTilesContainer>
      </SideMenuRightContainer>
    );
  }

  return (
    <section className={classes.fahrzeuge_car_policy_page}>
      <ComparisonPanel />
      <div className={`${classes.container} ${listView ? classes.list_view_container : classes.tile_view_container}`}>
        <VehicleOffersListComponent
          filterState={sessionFilter?.filterForServer}
          tableParams={tableParams}
          setTableParams={setTableParams}
          setDefaultPage={setDefaultPage}
          key={props.location.pathname}
          configurationType={configurationType}
          options={options}
          quickFilters={renderQuickFilters()}
          quickFilterContainerClassName={classes.filter_wrapper}
          listView={listView}
          changeListView={changeListView}
        >
          <FahrzeugeDerCarPolicyFilters
            key={props.location.pathname}
            sessionFilter={sessionFilter}
            setSessionFilter={setSessionFilter}
            goToFirstPage={goToFirstPage}
            allFiltersVisible={allFiltersVisible}
            allFiltersVisibilityHandler={setAllFiltersVisibility}
            listView={listView}
            changeListView={changeListView}
          />
        </VehicleOffersListComponent>
      </div>
      {!!comparisonCars.length && comparisonPanelOpen && <Distance top='160' />}
    </section>
  );
};

const getDefaultTableParams = (defaultPage, defaultNumber) => ({
  pagination: {
    start: defaultPage,
    number: defaultNumber
  },
  sort: {
    predicate: 'createdon',
    reverse: true
  },
  search: {}
});

export const EMTY_FILTER_STATE = {
  driverLevel: null,
  uds_enginetypecode: null,
  uds_carbrandid: null,
  uds_signeeid: null,
  uds_carmodelid: null,
  uds_kstverantw: null,
  events: [],
  carPolicy: null,
  accountId: null,
  contactId: null,
  uds_name: null
};

export const CRM_VALUE = {
  driverLevel: 'driverLevel',
  engineType: 'uds_enginetypecode',
  manufacturer: 'uds_carbrandid',
  releaser: 'uds_signeeid',
  model: 'uds_carmodelid',
  responsiblePerson: 'uds_kstverantw',
  status: 'events',
  carPolicy: 'carPolicy',
  company: 'accountId',
  driver: 'contactId',
  offerNumber: 'uds_name'
};

export default withRouter(FahrzeugeDerCarPolicyPage);
